import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { pluralize } from "@common/helpers/string";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { CommandsListProps } from "./lib";

export const ClientBulkCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const {
        selectedClientCount = 0,
        onClientBulkMemo,
        onClientBulkTeam,
        onClientBulkServices,
    } = options;

    const heading = `${selectedClientCount} ${pluralize("client", selectedClientCount)} selected`;

    return (
        <Command.Group heading={heading}>
            {onClientBulkMemo && (
                <CommandItem
                    keywords={["memo", "note"]}
                    shortcut="m"
                    onSelect={onClientBulkMemo}
                >
                    Memo
                </CommandItem>
            )}
            {onClientBulkTeam && (
                <CommandItem
                    keywords={["team", "member", "invite"]}
                    onSelect={onClientBulkTeam}
                >
                    Team
                </CommandItem>
            )}
            {onClientBulkServices && (
                <CommandItem
                    keywords={["service level", "services", "service"]}
                    onSelect={onClientBulkServices}
                >
                    Tiers
                </CommandItem>
            )}
        </Command.Group>
    );
};
